<template>
  <app-outline-main>
    <template #fixed-top>
      <div>
        <app-filter-group
            @reset="reset"
            @query="querySearch"
            class="gutter-bottom">
          <gj-country-server-select
              v-model="filter.countryMarketValue"
          ></gj-country-server-select>
          <gj-category-select
              multiple
              v-model="filter.categoryIds"
              :collapse-tags="true"
              placeholder="请选择品类"
              width="165px"
          >
          </gj-category-select>
          <gj-operation-state-select
              width="165px"
              placeholder="运营状态"
              v-model="filter.operationStates"
              multiple
          >
          </gj-operation-state-select>
          <gj-select-date-picker
              :type="filter.date.key === 0 ? 'daterange' : 'monthrange'"
              v-model="filter.date"
              :options="[
                      {id: 0, text: '日期'},
                      {id: 1, text: '月份'},
                  ]"
              :dateClearable="false"
              @shortcut-text="shortcutText = $event"
              :shortcut="filter.date.key === 0"
              @change="changeDatePciker"
          ></gj-select-date-picker>
          <template #right>
            <gj-tool-group help></gj-tool-group>
            <ViewSettingComponent
                    :ref="REF_VIEW_SETTING"
                    save-mode="remote"
                    :use-default="true"
                    :module-name="moduleName"
                    :config="model"
                    :fn-generate-params="generateViewParams"
                    @view-change="handleChangeView"
                    @view-complete="handCompleteView"
            >
              <template v-slot:dateRange="{ formData }">
                <gj-select
                        style="width: 130px"
                        v-model="formData.dateRangeType"
                        :options="pageEnums.DATE_TYPE_OPTIONS"
                        :clearable="false"
                        @change="() => formData.dateRange = 0"
                ></gj-select>
                <gj-select
                        style="margin-left: 8px;width: 130px;"
                        v-model="formData.dateRange"
                        :options="formData.dateRangeType === 'DAY' ? pageEnums.timeRangeOptions : pageEnums.monthRangeOptions"/>
              </template>
            </ViewSettingComponent>
          </template>
        </app-filter-group>
      </div>
    </template>
    <div class="hello" v-if="canRequest">
      <app-outline-content label="综合分析">
        <vue-lazy-component :viewport="root">
          <!--综合分析-->
          <comprehensive-analysis ref="comprehensiveAnalysis" :filter="filter"></comprehensive-analysis>
          <OptionCard :info="{ title: '综合分析' }" slot="skeleton" class="option-analysis" v-loading="true">
            <div style="height: 544px;"></div>
          </OptionCard>
        </vue-lazy-component>
      </app-outline-content>
      <app-outline-content label="销售分析">
        <vue-lazy-component :viewport="root">
          <!--店铺-盈利分析-->
          <profit-analysis ref="profitAnalysis" :filter="filter"></profit-analysis>
          <OptionCard :info="{ title: '盈利分析' }" slot="skeleton" class="option-analysis" v-loading="true">
            <div style="height: 533px;"></div>
          </OptionCard>
        </vue-lazy-component>
        <vue-lazy-component :viewport="root">
          <!--指标明细-->
          <index-details ref="indexDetails" :filter="filter"></index-details>
          <OptionCard :info="{ title: '指标明细' }" slot="skeleton" class="option-analysis" v-loading="true">
            <div style="height: 509px;"></div>
          </OptionCard>
        </vue-lazy-component>
        <vue-lazy-component :viewport="root">
          <!--订单站点分布与订单量累计分布-->
          <order-site-distribution ref="orderSiteDistribution" :filter="filter"></order-site-distribution>
          <OptionCard :info="{ title: '订单站点分布与订单量累计分布' }" slot="skeleton" class="option-analysis" v-loading="true">
            <div style="height: 544px;"></div>
          </OptionCard>
        </vue-lazy-component>
        <vue-lazy-component :viewport="root">
          <!--订单站点分布与订单量累计分布-->
          <OrderRegionalDistribution ref="OrderRegionalDistribution" :filter="filter"></OrderRegionalDistribution>
          <OptionCard :info="{ title: '订单站点分布与订单量累计分布' }" slot="skeleton" class="option-analysis" v-loading="true">
            <div style="height: 544px;"></div>
          </OptionCard>
        </vue-lazy-component>
      </app-outline-content>
      <app-outline-content label="广告分析">
        <vue-lazy-component :viewport="root">
          <!--广告分析-->
          <advertising-analysis ref="advertisingAnalysis" :filter="filter"></advertising-analysis>
          <OptionCard :info="{ title: '广告分析' }" slot="skeleton" class="option-analysis" v-loading="true">
            <div style="height: 734px;"></div>
          </OptionCard>
        </vue-lazy-component>
      </app-outline-content>
      <app-outline-content label="费用利润">
        <vue-lazy-component :viewport="root">
          <!--费用利润-->
          <percentage-store-expenses ref="percentageStoreExpenses" :filter="filter"></percentage-store-expenses>
          <OptionCard :info="{ title: '费用利润' }" slot="skeleton" class="option-analysis" v-loading="true">
            <div style="height: 809px;"></div>
          </OptionCard>
        </vue-lazy-component>
      </app-outline-content>
      <app-outline-content label="买家评论">
        <vue-lazy-component :viewport="root">
          <!--Review分析-->
          <review-analysis ref="reviewAnalysis" :filter="filter"></review-analysis>
          <OptionCard :info="{ title: '买家评论' }" slot="skeleton" class="option-analysis" v-loading="true">
            <div style="height: 545px;"></div>
          </OptionCard>
        </vue-lazy-component>
      </app-outline-content>
      <app-outline-content label="全店铺绩效">
        <vue-lazy-component :viewport="root">
          <!--全店铺绩效-->
          <store-performance ref="storePerformance" :filter="filter"></store-performance>
          <OptionCard :info="{ title: '全店铺绩效' }" slot="skeleton" class="option-analysis" v-loading="true">
            <div style="height: 780px;"></div>
          </OptionCard>
        </vue-lazy-component>
      </app-outline-content>
    </div>
  </app-outline-main>
</template>

<script>
 import _ from "lodash";
 import ComprehensiveAnalysis from "@/views/modules/statistics/shop-wide-analysis/modules/comprehensive-analysis.vue"
 import ProfitAnalysis from "@/views/modules/statistics/shop-wide-analysis/modules/profit-analysis"
 import IndexDetails from "@/views/modules/statistics/shop-wide-analysis/modules/index-details"
 import OrderSiteDistribution from "@/views/modules/statistics/shop-wide-analysis/modules/order-site-distribution.vue"
 import OrderRegionalDistribution from "@/views/modules/statistics/shop-wide-analysis/modules/order-regional-distribution"
 import AdvertisingAnalysis from "@/views/modules/statistics/shop-wide-analysis/modules/advertising-analysis.vue"
 import PercentageStoreExpenses from "@/views/modules/statistics/shop-wide-analysis/modules/percentage-store-expenses"
 import ReviewAnalysis from "@/views/modules/statistics/shop-wide-analysis/modules/review-analysis.vue"
 import ViewSettingComponent from 'components/view-setting/view-setting'

 //店铺绩效延后
 import StorePerformance from "@/views/modules/statistics/shop-wide-analysis/modules/store-performance"
 import {queryMixin} from "@/minxins";
 import {startOfMonth, subDays, endOfMonth,format, startOfWeek, endOfWeek, startOfYear} from "date-fns";
 import {convertToDate, convertToFullDate, convertToMonth} from "@/utils/date.util";
 import {SHOP_WIDE_MODULE} from "@/utils/const";
 import { timeRangeOptions, monthRangeOptions, DATE_TYPE_OPTIONS } from "@/utils/options";
 import OptionCard from '@/views/components/option-card/option-card'
 import {isMeaningful} from "@/utils/common";
 import VIEW_SHOP_WIDE_SETTING from "modules/statistics/shop-wide-analysis/common/viewConfig";


export default {
  name: "shop-wide-analysis",
  components:{
    ComprehensiveAnalysis,
    ProfitAnalysis,
    IndexDetails,
    OrderSiteDistribution,
    OrderRegionalDistribution,
    AdvertisingAnalysis,
    PercentageStoreExpenses,
    ReviewAnalysis,
    OptionCard,
    ViewSettingComponent,
    StorePerformance
  },
  mixins: [queryMixin],
  provide() {
    return {
      getPageParams: () => this.filter
    }
  },
  data(){
    return{
      shortcuts: ['今天', '昨天', '近7天', '近30天', '本月', '上月', '本年至今'],
      reportType: '',
      pageEnums: {
        timeRangeOptions,
        monthRangeOptions,
        DATE_TYPE_OPTIONS
      },
      filter: {
        countryMarketValue: {
          countryCodes: [],
          marketIds: []
        },
        categoryIds: [],
        countryCodes: [],
        marketIds: [],
        operationStates: [],
        dateRangeType: "DAY",
        startDateTime: convertToFullDate(subDays(new Date(), 13), 'yyyy-MM-dd'),
        endDateTime: convertToFullDate(new Date(), 'yyyy-MM-dd'),
        date: {
            key: 0,
            value: [subDays(new Date(), 13), new Date()],
        },
        shortcutText: null,
      },
      //右上角视图部分
      viewData: [],
      currentView: '',
      canRequest: false,   //先加载配置项，在渲染界面
      //文档节点
      root: document.querySelector('.hello'),
      hasDefaultView: true,
      moduleName: SHOP_WIDE_MODULE,
      model: VIEW_SHOP_WIDE_SETTING,
      cacheOptions: {
        useCache: true,
      }
    }
  },
  beforeRouteEnter (route, from, next) {
      const { query } = route
      if (JSON.stringify(query) !== '{}') {
          next(vm => {
              vm.initParams()
              vm.query()
          })
      }
      next()
  },
  created() {
    this.initParams()
  },
  methods:{
    querySearch() {
      this.setCacheData()
      this.query()
    },
    /**
     * 初始化路由参数
     */
    initParams () {
        let { params } = this.$route.query
        if (params) {
            try {
                params = JSON.parse(params)
                const filter = this.filter
                if (params.date.type && params.date.value && params.date.value.length) {
                  this.filter.dateRangeType = params.date.type ? params.date.type : filter.dateRangeType // 日期类型
                  this.filter.date.key =  params.date.type == 'MONTH' ? 1 : filter.date.key // 日期类型
                  this.filter.date.value = [
                    params.date.value[0] ? new Date(params.date.value[0]) : filter.date.value[0], // 开始日期
                    params.date.value[1] ? new Date(params.date.value[1]) : filter.date.value[1] // 结束日期
                  ]
                  this.filter.startDateTime = params.date.value[0] ? params.date.value[0] : filter.startDateTime // 开始日期
                  this.filter.endDateTime = params.date.value[1] ? params.date.value[1] : filter.endDateTime // 结束日期
                }
                this.filter.countryCodes = params.countryData.countryIds ? params.countryData.countryIds : filter.countryCodes // 国家
                this.filter.marketIds = params.countryData.marketIds ? params.countryData.marketIds : filter.marketIds // 店铺
                this.filter.countryMarketValue = params.countryData ? params.countryData : filter.countryMarketValue
            } catch (e) {
                console.warn(e)
            }
        }
    },
    /**
     * 初始化全局查询参数
     */
    $gjQueryInitParams(){

    },
    /**
     * 修改日期
     */
    changeDatePciker(value){
    },
    customHandView() {
      const params = this.getCacheData() || {}
      const query = this.$route.query
      if (params.query && JSON.stringify(query) == '{}') {
        this.mergeRemoteParams(params.query)
      }
      this.$nextTick(() => {
        this.canRequest = !!this.filter?.date?.value?.length
      })
    },
    loadViewComplete () {
      
    },
    /**
     *
     * @param params 查询条件参数
     * @override queryMixin
     * @returns {{ countryMarketValue: *}}
     */
    $gjCacheCallback(params) {
      return {
        countryMarketValue: params.countryMarketValue
      };
    },
    /**
     * 全局查询
     */
    query(){
      let dateFormat;
      if (this.filter.date.key === 0) {
        dateFormat = 'yyyy-MM-dd'
      } else {
        dateFormat = 'yyyy-MM'
      }

      const startDateTime = typeof this.filter.date.value[0] === 'string'
        ? convertToFullDate(new Date(this.filter.date.value[0]), dateFormat)
        : convertToFullDate(this.filter.date.value[0], dateFormat);
      const endDateTime = typeof this.filter.date.value[1] === 'string'
        ? convertToFullDate(new Date(this.filter.date.value[1]), dateFormat)
        : convertToFullDate(this.filter.date.value[1], dateFormat);

      this.filter = {
        countryMarketValue: this.filter.countryMarketValue,
        countryCodes: this.filter.countryMarketValue ? this.filter.countryMarketValue.countryIds : [],
        marketIds : this.filter.countryMarketValue ? !_.isEmpty(this.filter.countryMarketValue.marketIds) ? this.filter.countryMarketValue.marketIds: [] : [],
        categoryIds: this.filter.categoryIds,
        operationStates: this.filter.operationStates || [],
        dateRangeType: this.filter.date.key === 0 ? "DAY" :"MONTH",
        startDateTime,
        endDateTime,
        date: this.filter.date,
      }

      const refsInstance = this.$refs

      this.canRequest = true
      Object.values(refsInstance).forEach(v => {
        v && v.refresh && v.refresh()
      })

    },
    /**
     * 重置全部参数查询
     */
    reset() {
      this.currentView = null
      this.filter = {
        countryMarketValue: {
          countryCodes: [],
          marketIds: []
        },
        categoryIds: [],
        countryCodes: this.filter.countryMarketValue ? this.filter.countryMarketValue.countryIds : [],
        marketIds : this.filter.countryMarketValue ? this.filter.countryMarketValue.marketIds : [],
        operationStates: [],
        dateRangeType: "DAY",
        startDateTime: convertToFullDate(subDays(new Date(), 13), 'yyyy-MM-dd'),
        endDateTime: convertToFullDate(new Date(), 'yyyy-MM-dd'),
        date: {
          key: this.filter.date.key,
          value: [subDays(new Date(), 13), new Date()],
        },
      };

      const refsInstance = this.$refs

      this.canRequest = true
      Object.values(refsInstance).forEach(v => {
        v && v.refresh && v.refresh()
      })
      this.$gjCacheReset()
    },
    /**
     * 选择默认视图
     */
    handleResetPageParams(item){
      this.currentView = null
      this.filter = {
        countryMarketValue: {
          countryCodes: [],
          marketIds: []
        },
        categoryIds: [],
        countryCodes: this.filter.countryMarketValue ? this.filter.countryMarketValue.countryIds : [],
        marketIds : this.filter.countryMarketValue ? this.filter.countryMarketValue.marketIds : [],
        operationStates: [],
        dateRangeType: "DAY",
        startDateTime: convertToFullDate(subDays(new Date(), 13), 'yyyy-MM-dd'),
        endDateTime: convertToFullDate(new Date(), 'yyyy-MM-dd'),
        date: {
          key: 0,
          value: [subDays(new Date(), 13), new Date()],
        },
        shortcutText: null,
      };
    },
    /**
     * 根据自定义视图获取默认配置
     */
    mergeRemoteParams(params) {
      let {
        categoryIds,
        operationStates,
        countryMarketValue,
        dateRangeType = 'DAY',
        startDateTime=convertToFullDate(subDays(new Date(), 13), 'yyyy-MM-dd'),
        endDateTime=convertToFullDate(new Date(), 'yyyy-MM-dd'),
      } = params;

      const { countryIds = [], marketIds = [] } = countryMarketValue || {};

      this.filter = {
        countryMarketValue: {countryIds, marketIds},
        categoryIds : !_.isEmpty(categoryIds) ? categoryIds : [],
        countryCodes: !_.isEmpty(countryIds) ? countryIds : [],
        marketIds,
        operationStates: !_.isEmpty(operationStates) ? operationStates : [],
        dateRangeType,
        startDateTime,
        endDateTime,
        date: {
          key: params.dateRangeType === 'DAY' ? 0 : 1,
          value: [startDateTime, endDateTime],
        },
      }
    },
    /**
     * 构造视图参数
     */
    generateViewParams (params) {
      let [ startDateTime = '', endDateTime = '' ] = this.generatorTrulyDateTime(params.dateRangeType, params.dateRange)
      params.startDateTime = params.dateRangeType === 'DAY' ? convertToDate(startDateTime) : convertToMonth(startDateTime)
      params.endDateTime = params.dateRangeType === 'DAY' ? convertToDate(endDateTime) : convertToMonth(endDateTime)
      return Promise.resolve(params)
    },
    /**
     * 处理选中时间
     * @param dateRangeType 选择时间范围的类型
     * @param dateRange 时间范围
     */
    generatorTrulyDateTime (dateRangeType = 'DAY', dateRange = 0) {
      return dateRangeType === 'DAY' ? this.generatorDate(dateRange) : this.generatorMonth(dateRange)
    },
    /**
     * 处理选中月份
     * @param dateRange 选择值
     * @returns {{startDateTime: string, endDateTime: string}|Date[]}
     */
    generatorMonth (dateRange) {
      if (!isMeaningful(dateRange)) return ['', '']
      let end = new Date()
      let start = new Date()
      switch (dateRange) {
        case 1:
          start.setMonth(start.getMonth() - 1)
          end.setMonth(end.getMonth() - 1)
          break;
        case 2:
          start.setMonth(start.getMonth() - 2)
          break
        case 3:
          start.setMonth(start.getMonth() - 6)
          break
        case 4:
          start = new Date(start.getFullYear(), 0)
          break
      }
      return [start, end]
    },
    /**
     * 处理选中日期范围
     * @param dateRange 选中值
     * @returns {{startDateTime: string, endDateTime: string}|Date[]}
     */
    generatorDate (dateRange) {
      if (!isMeaningful(dateRange)) return ['', '']
      let end = new Date()
      let start = new Date()
      switch (dateRange) {
        case 1:
          start = subDays(start, 1)
          end = start
          break;
        case 2:
          start = subDays(start, 6)
          break
        case 3:
          start = subDays(start, 13)
          break
        case 4:
          start = subDays(start, 29)
          break
        case 5:
          start = subDays(start, 59)
          break
        case 6:
          start = startOfWeek(start)
          end = endOfWeek(end)
          break
        case 7:
          start = startOfMonth(start)
          end = endOfMonth(end)
          break
        case 8:
          start = startOfYear(start)
          break
      }

      return [start, end]
    },
    /**
     * 切换视图
     */
    async handleChangeView (view) {
      if (view && view.params) {
        try {
          let params = JSON.parse(view.params)
          if (params) {
            this.mergeRemoteParams(params)
            this.query()
          }
        } catch (e) {
          console.warn(e)
        }
      } else {
        this.handleResetPageParams()
        this.query()
      }
    },
  },
}
</script>

<style scoped>
/deep/ .fixed-top-wrapper{
  margin-bottom: 12px;
  padding-right: 0;
}
.main-content{
  /*padding-top: 150px;*/
  /*margin-top: -120px;*/
  width: 100%;
  height: 100%;
  overflow-y: auto;
  /*background: white;*/
  /*margin-bottom: 10px;*/
}
.divide-bg{
  height: 10px;
  width: 100%;
  background: #f6f6f6;
}
.align-center>span{
  font-size: 14px;
}

.custom-view {}
.custom-view:hover > span {
  color: #1F6EEF!important;
}

.custom-view:hover > span > i {
  color: #1F6EEF!important;
}
</style>
